import { DataLoader, EmptyContainer, LoadingContainer, SuccessContainer } from "../../../components/DataLoader";
import { InfiniteScrollContainer } from "../../../components/InfiniteScrollContainer";
import { HistoryTable, NoPublished } from "../../../components/ScriptsComponents";
import type { HistoryDraft } from "../../../components/ScriptsComponents/DraftsCommon";
import { CountDisplay } from "../../../components/ui/CountDisplay";
import { SkeletonRow, SkeletonTable } from "../../../components/ui/skeletons";
import { HISTORY_LIST_QUERY } from "../../../graphql";

const PAGE_SIZE = 20;

export const HistoryBrowser = () => {
  const variables = {
    first: PAGE_SIZE,
  };

  return (
    <InfiniteScrollContainer
      first={PAGE_SIZE}
      className={"published-history"}
      query={HISTORY_LIST_QUERY}
      variables={variables}
      nodeName="history"
    >
      {({ loading, error, results, hasResults, isLoadingMore }) => {
        const rowCount = results ? results.length : 0;
        return (
          <DataLoader
            loading={loading && !isLoadingMore}
            error={error}
            success={hasResults}
            defaults={{ small: false }}
          >
            <LoadingContainer>
              <SkeletonTable rows={10} />
            </LoadingContainer>
            <EmptyContainer>
              <NoPublished />
            </EmptyContainer>
            <SuccessContainer>
              <HistoryTable drafts={results as HistoryDraft[] | null} />
              {isLoadingMore ? <SkeletonRow /> : null}
              <CountDisplay count={rowCount} testLabel="row-count-top" entity="row" />
            </SuccessContainer>
          </DataLoader>
        );
      }}
    </InfiniteScrollContainer>
  );
};
